import React from "react"
import {withFormik} from 'formik';
import {FormattedMessage, injectIntl} from "react-intl";
import {displayErrors, parsePropertiesErrors} from "../../../../form-helpers";
import BaseComponent from "../../../base-component";
import {Collapse} from "reactstrap";
import Datetime from "react-datetime";
import CountrySelect from "../../../country-select";
import Cleave from 'cleave.js/src/Cleave.react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

class Page3 extends BaseComponent {

    constructor(params) {
        super(params);
    }

    setCitizenship = (value) => {
        this.props.setFieldValue('data.citizenship', value);
        if (!['CZE', 'SVK'].includes(value)) {
            this.props.setFieldValue('data.personal_identification_number','');
        }
    };

    render() {
        const { intl, values, touched, errors, handleChange, handleBlur, handleSubmit, submitForm, isSubmitting, setFieldValue, isComplete } = this.props;
        const isSKCZ = ['CZE', 'SVK'].includes(values.data.citizenship);

        return (
            <form onSubmit={handleSubmit}>
                <h3><FormattedMessage id='app.personal_forms.page_3.title'/></h3>
                <p><FormattedMessage id='app.personal_forms.page_3.info'/></p>
                <p><FormattedMessage id='app.personal_forms.message.required_fields'/> (<span className='text-red'>*</span>)</p>
                <hr/>
                { displayErrors(errors, 'base') }

                <div className='row'>
                    <div className='col-md-6'>
                        <FormattedMessage id='app.personal_forms.attribute.date_of_birth'>{(txt) => (<label className={'required-field'}>{txt}</label>)}</FormattedMessage>
                        <div className='row'>
                            <div className='col-4'>
                                <div className='form-group'>
                                    <FormattedMessage id='app.personal_forms.attribute.date_of_birth_day'>{(txt) => (<label className='small'>{txt}</label>)}</FormattedMessage>
                                    <select disabled={isComplete} id='data.date_of_birth_day' value={values.data.date_of_birth_day} onChange={handleChange} className='form-control'>
                                        <option value=''>-</option>
                                        <option>01</option>
                                        <option>02</option>
                                        <option>03</option>
                                        <option>04</option>
                                        <option>05</option>
                                        <option>06</option>
                                        <option>07</option>
                                        <option>08</option>
                                        <option>09</option>
                                        <option>10</option>
                                        <option>11</option>
                                        <option>12</option>
                                        <option>13</option>
                                        <option>14</option>
                                        <option>15</option>
                                        <option>16</option>
                                        <option>17</option>
                                        <option>18</option>
                                        <option>19</option>
                                        <option>20</option>
                                        <option>21</option>
                                        <option>22</option>
                                        <option>23</option>
                                        <option>24</option>
                                        <option>25</option>
                                        <option>26</option>
                                        <option>27</option>
                                        <option>28</option>
                                        <option>29</option>
                                        <option>30</option>
                                        <option>31</option>
                                    </select>
                                    { displayErrors(errors, 'data.date_of_birth_day') }
                                    { displayErrors(errors, 'data.date_of_birth') }
                                </div>
                            </div>
                            <div className='col-4'>
                                <div className='form-group'>
                                    <FormattedMessage id='app.personal_forms.attribute.date_of_birth_month'>{(txt) => (<label className='small'>{txt}</label>)}</FormattedMessage>
                                    <select disabled={isComplete} id='data.date_of_birth_month' value={values.data.date_of_birth_month} onChange={handleChange} className='form-control'>
                                        <option value=''>-</option>
                                        <option>01</option>
                                        <option>02</option>
                                        <option>03</option>
                                        <option>04</option>
                                        <option>05</option>
                                        <option>06</option>
                                        <option>07</option>
                                        <option>08</option>
                                        <option>09</option>
                                        <option>10</option>
                                        <option>11</option>
                                        <option>12</option>
                                    </select>
                                    { displayErrors(errors, 'data.date_of_birth_month') }
                                </div>
                            </div>
                            <div className='col-4'>
                                <div className='form-group'>
                                    <FormattedMessage id='app.personal_forms.attribute.date_of_birth_year'>{(txt) => (<label className='small'>{txt}</label>)}</FormattedMessage>
                                    <select disabled={isComplete} id='data.date_of_birth_year' value={values.data.date_of_birth_year} onChange={handleChange} className='form-control'>
                                        <option value=''>-</option>
                                        { Array.from({length: 110}, (v, k) => 2010 - k).map((year) => (
                                            <option key={year}>{year}</option>
                                            )
                                        ) }
                                    </select>
                                    { displayErrors(errors, 'data.date_of_birth_year') }
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <div className='row'>
                    <div className='col-md-6'>
                        <div className='form-group'>
                            <FormattedMessage id='app.personal_forms.attribute.citizenship'>{(txt) => (<label className={'required-field'}>{txt}</label>)}</FormattedMessage>
                            <CountrySelect disabled={isComplete} value={values.data.citizenship} onChange={this.setCitizenship}/>
                            { displayErrors(errors, 'data.citizenship') }
                        </div>
                    </div>
                </div>
                <div className='row'>
                    <div className={`col-md-${ isSKCZ ? '4' : '6' }`}>
                        <div className='form-group'>
                            <FormattedMessage id='app.personal_forms.attribute.country_of_birth'>{(txt) => (<label className={'required-field'}>{txt}</label>)}</FormattedMessage>
                            <CountrySelect disabled={isComplete} value={values.data.country_of_birth} onChange={(value) => { setFieldValue('data.country_of_birth', value) }}/>
                            { displayErrors(errors, 'data.country_of_birth') }
                        </div>
                    </div>
                    <div className={`col-md-${ isSKCZ ? '4' : '6' }`}>
                        <div className='form-group'>
                            <FormattedMessage id='app.personal_forms.attribute.place_of_birth'>{(txt) => (<label className={'required-field'}>{txt}</label>)}</FormattedMessage>
                            <input disabled={isComplete} type="text" className='form-control' id='data.place_of_birth' value={values.data.place_of_birth} onChange={handleChange}/>
                            { displayErrors(errors, 'data.place_of_birth') }
                        </div>
                    </div>
                    {
                        isSKCZ &&
                        <div className='col-md-4'>
                            <div className='form-group'>
                                <FormattedMessage id='app.personal_forms.attribute.personal_identification_number'>{(txt) => (<label className={'required-field'}>{txt}</label>)}</FormattedMessage>
                                <Cleave options={{
                                    numericOnly: true,
                                    blocks: [6, 4]
                                }}
                                        value={values.data.personal_identification_number}
                                        disabled={isComplete}
                                        className={'form-control'}
                                        onChange={(event) => {
                                            setFieldValue('data.personal_identification_number', event.target.rawValue);
                                            setFieldValue('data.personal_identification_number_check', false)
                                        }} />
                                <div className='small text-muted shift'><FormattedMessage id='app.personal_forms.attribute.personal_identification_number.info'/></div>
                                <div>
                                    { displayErrors(errors, 'data.personal_identification_number') }
                                </div>
                                {
                                    ( ( errors.data && errors.data.personal_identification_number ) || values.data.personal_identification_number_check === true ) &&
                                    <div>
                                        <div className='custom-control custom-checkbox'>
                                            <input className='custom-control-input' disabled={isComplete}
                                                   id='data.personal_identification_number_check' name='data.personal_identification_number_check' type="checkbox"
                                                   value={values.data.personal_identification_number_check}
                                                   checked={values.data.personal_identification_number_check} onChange={handleChange}
                                                   onBlur={handleBlur}/>
                                            <label className='custom-control-label' htmlFor='data.personal_identification_number_check'><FormattedMessage id='app.personal_forms.attribute.personal_identification_number_check'/></label>
                                        </div>
                                    </div>
                                }
                                {
                                    values.data.personal_identification_number.length > 0 && ( !errors.data || !errors.data.personal_identification_number || values.data.personal_identification_number_check === true ) &&
                                    <div className='shift small text-muted mt-1'><FontAwesomeIcon className='text-success mr-1' icon={['fas','check-circle']}/><FormattedMessage id={'app.personal_forms.attribute.personal_identification_number.correct'}/></div>
                                }
                            </div>
                        </div>
                    }
                </div>
                <div className='row'>
                    <div className='col-md-6'>
                        <div className='form-group'>
                            <FormattedMessage id='app.personal_forms.attribute.student'>{(txt) => (<label className={'required-field'}>{txt}</label>)}</FormattedMessage><br/>
                            <div className="custom-control custom-radio">
                                <input className='custom-control-input' disabled={isComplete} id='data.student' name='data.student' type="radio" value={values.data.student} checked={values.data.student === '1'} onChange={() => { setFieldValue('data.student', '1') }} onBlur={handleBlur}/>
                                <label className='custom-control-label' onClick={() => { !isComplete && setFieldValue('data.student', '1') }}><FormattedMessage id='app.personal_forms.attribute.student.true'/></label>
                            </div>
                            <div className="custom-control custom-radio">
                                <input className='custom-control-input' disabled={isComplete} id='data.student' name='data.student' type="radio" value={values.data.student} checked={values.data.student === '0'} onChange={() => { setFieldValue('data.student', '0') }} onBlur={handleBlur}/>
                                <label className='custom-control-label' onClick={() => { !isComplete && setFieldValue('data.student', '0') }}><FormattedMessage id='app.personal_forms.attribute.student.false'/></label>
                            </div>
                            { displayErrors(errors, 'data.student') }
                        </div>
                    </div>
                </div>

                <div className='row'>
                    <div className='col-md-6'>
                        <div className='form-group'>
                            <FormattedMessage id='app.personal_forms.attribute.drivers_license'>{(txt) => (<label className={'required-field'}>{txt}</label>)}</FormattedMessage><br/>
                            <div className="custom-control custom-radio">
                                <input className='custom-control-input' disabled={isComplete} id='data.drivers_license' name='data.drivers_license' type="radio" value={values.data.drivers_license} checked={values.data.drivers_license === '1'} onChange={() => { setFieldValue('data.drivers_license', '1') }} onBlur={handleBlur}/>
                                <label className='custom-control-label' onClick={() => { !isComplete && setFieldValue('data.drivers_license', '1') }}><FormattedMessage id='app.personal_forms.attribute.drivers_license.true'/></label>
                            </div>
                            <div className="custom-control custom-radio">
                                <input className='custom-control-input' disabled={isComplete} id='data.drivers_license' name='data.drivers_license' type="radio" value={values.data.drivers_license} checked={values.data.drivers_license === '0'} onChange={() => { setFieldValue('data.drivers_license', '0') }} onBlur={handleBlur}/>
                                <label className='custom-control-label' onClick={() => { !isComplete && setFieldValue('data.drivers_license', '0') }}><FormattedMessage id='app.personal_forms.attribute.drivers_license.false'/></label>
                            </div>
                            { displayErrors(errors, 'data.drivers_license') }
                        </div>
                    </div>
                    {
                        values.data.drivers_license === '1' &&
                        <div className='col-md-6'>
                            <FormattedMessage id='app.personal_forms.attribute.drivers_license_group'>{(txt) => (<label className={values.data.drivers_license === '1' ? 'required-field' : ''}>{txt}</label>)}</FormattedMessage>
                            <input disabled={isComplete} type="text" className='form-control' id='data.drivers_license_group' value={values.data.drivers_license_group} onChange={handleChange}/>
                            { displayErrors(errors, 'data.drivers_license_group') }
                        </div>
                    }
                </div>
                <div className='row'>
                    <div className='col-md-6'>
                        <div className='form-group'>
                            <FormattedMessage id='app.personal_forms.attribute.retiree'>{(txt) => (<label className={'required-field'}>{txt}</label>)}</FormattedMessage><br/>
                            <div className='custom-control custom-radio'>
                                <input className='custom-control-input' disabled={isComplete} id='data.retiree' name='data.retiree' type="radio" value={values.data.retiree} checked={values.data.retiree === '1'} onChange={() => { setFieldValue('data.retiree', '1') }} onBlur={handleBlur}/>
                                <label className='custom-control-label' onClick={() => { !isComplete && setFieldValue('data.retiree', '1'); }}><FormattedMessage id='app.personal_forms.attribute.retiree.true'/></label>
                            </div>
                            <div className='custom-control custom-radio'>
                                <input className='custom-control-input' disabled={isComplete} id='data.retiree' name='data.retiree' type="radio" value={values.data.retiree} checked={values.data.retiree === '0'} onChange={() => { setFieldValue('data.retiree', '0') }} onBlur={handleBlur}/>
                                <label className='custom-control-label' onClick={() => { !isComplete && setFieldValue('data.retiree', '0') }}><FormattedMessage id='app.personal_forms.attribute.retiree.false'/></label>
                            </div>
                            { displayErrors(errors, 'data.retiree') }
                        </div>
                    </div>
                    {
                        values.data.retiree === '1' &&
                        <div className='col-md-6'>
                            <div className='form-group'>
                                <FormattedMessage id='app.personal_forms.attribute.retirement_type'>{(txt) => (<label className={values.data.retiree === '1' ? 'required-field' : ''}>{txt}</label>)}</FormattedMessage>
                                <input disabled={isComplete} type="text" className='form-control' id='data.retirement_type' value={values.data.retirement_type} onChange={handleChange}/>
                                { displayErrors(errors, 'data.retirement_type') }
                            </div>
                        </div>
                    }
                </div>

                <div className='row'>
                    <div className='col-md-4'>
                        <div className='form-group'>
                            <FormattedMessage id='app.personal_forms.attribute.disability'>{(txt) => (<label className={'required-field'}>{txt}</label>)}</FormattedMessage><br/>
                            <div className='custom-control custom-radio'>
                                <input className='custom-control-input' disabled={isComplete} id='data.disability' name='data.disability' type="radio" value={values.data.disability} checked={values.data.disability === '1'} onChange={() => { setFieldValue('data.disability', '1') }} onBlur={handleBlur}/>
                                <label className='custom-control-label' onClick={() => { !isComplete && setFieldValue('data.disability', '1'); }}><FormattedMessage id='app.personal_forms.attribute.disability.true'/></label>
                            </div>
                            <div className='custom-control custom-radio'>
                                <input className='custom-control-input' disabled={isComplete} id='data.disability' name='data.disability' type="radio" value={values.data.disability} checked={values.data.disability === '0'} onChange={() => { setFieldValue('data.disability', '0') }} onBlur={handleBlur}/>
                                <label className='custom-control-label' onClick={() => { !isComplete && setFieldValue('data.disability', '0') }}><FormattedMessage id='app.personal_forms.attribute.disability.false'/></label>
                            </div>
                            { displayErrors(errors, 'data.disability') }
                        </div>
                    </div>
                    <div className='col-md-4'>
                        <div className='form-group'>
                            <FormattedMessage id='app.personal_forms.attribute.invalidity'>{(txt) => (<label className={'required-field'}>{txt}</label>)}</FormattedMessage><br/>
                            <div className='custom-control custom-radio'>
                                <input className='custom-control-input' disabled={isComplete} id='data.invalidity' name='data.invalidity' type="radio" value={values.data.invalidity} checked={values.data.invalidity === '1'} onChange={() => { setFieldValue('data.invalidity', '1') }} onBlur={handleBlur}/>
                                <label className='custom-control-label' onClick={() => { !isComplete && setFieldValue('data.invalidity', '1'); }}><FormattedMessage id='app.personal_forms.attribute.invalidity.true'/></label>
                            </div>
                            <div className='custom-control custom-radio'>
                                <input className='custom-control-input' disabled={isComplete} id='data.invalidity' name='data.invalidity' type="radio" value={values.data.invalidity} checked={values.data.invalidity === '0'} onChange={() => { setFieldValue('data.invalidity', '0') }} onBlur={handleBlur}/>
                                <label className='custom-control-label' onClick={() => { !isComplete && setFieldValue('data.invalidity', '0') }}><FormattedMessage id='app.personal_forms.attribute.invalidity.false'/></label>
                            </div>
                            { displayErrors(errors, 'data.invalidity') }
                        </div>
                    </div>
                    {
                        values.data.invalidity === '1' &&
                        <div className='col-md-4'>
                            <div className='form-group'>
                                <FormattedMessage id='app.personal_forms.attribute.invalidity_levels'>{(txt) => (<label
                                    className={values.data.invalidity === '1' ? 'required-field' : ''}>{txt}</label>)}</FormattedMessage><br/>
                                <div className='custom-control custom-checkbox'>
                                    <input className='custom-control-input' disabled={isComplete}
                                           id='data.invalidity_level_1' name='data.invalidity_level_1' type="checkbox"
                                           value={values.data.invalidity_level_1}
                                           checked={values.data.invalidity_level_1} onChange={handleChange}
                                           onBlur={handleBlur}/>
                                    <label className='custom-control-label'
                                           htmlFor='data.invalidity_level_1'><FormattedMessage
                                        id='app.personal_forms.attribute.invalidity_level_1'/></label>
                                </div>
                                <div className='custom-control custom-checkbox'>
                                    <input className='custom-control-input' disabled={isComplete}
                                           id='data.invalidity_level_2' name='data.invalidity_level_2' type="checkbox"
                                           value={values.data.invalidity_level_2}
                                           checked={values.data.invalidity_level_2} onChange={handleChange}
                                           onBlur={handleBlur}/>
                                    <label className='custom-control-label'
                                           htmlFor='data.invalidity_level_2'><FormattedMessage
                                        id='app.personal_forms.attribute.invalidity_level_2'/></label>
                                </div>
                                <div className='custom-control custom-checkbox'>
                                    <input className='custom-control-input' disabled={isComplete}
                                           id='data.invalidity_level_3' name='data.invalidity_level_3' type="checkbox"
                                           value={values.data.invalidity_level_3}
                                           checked={values.data.invalidity_level_3} onChange={handleChange}
                                           onBlur={handleBlur}/>
                                    <label className='custom-control-label'
                                           htmlFor='data.invalidity_level_3'><FormattedMessage
                                        id='app.personal_forms.attribute.invalidity_level_3'/></label>
                                </div>
                                {displayErrors(errors, 'data.invalidity_levels')}
                            </div>
                        </div>
                    }
                </div>

                <div className='clearfix'>
                    <hr/>
                    <button type='button' className='btn btn-secondary' onClick={this.props.previous}>{intl.formatMessage({id: 'app.personal_forms.buttons.previous_step'})}</button>
                    { !isComplete && <button type='submit' className='btn btn-primary float-right' disabled={isSubmitting || Object.keys(errors).length !== 0 }>{intl.formatMessage({id: 'app.personal_forms.buttons.next_step'})}{this.spinner(isSubmitting)}</button> }
                    { isComplete && <button type='button' className='btn btn-primary float-right' onBlur={handleBlur} onClick={this.props.next}>{intl.formatMessage({id: 'app.personal_forms.buttons.next_step'})}</button> }
                </div>
            </form>
        )
    }

}

const validatePIN = function (values, props) {
    const PIN_errors = [];

    const isSKCZ = ['CZE', 'SVK'].includes(values.data.citizenship);
    if ( !isSKCZ ) return PIN_errors;

    const PIN = values.data.personal_identification_number;
    const PIN_check = values.data.personal_identification_number_check;

    const PIN_length = PIN.length;

    if (PIN_check === true && PIN_length > 0) return [];

    // Length

    const year = PIN.substring(0,2);
    const month = PIN.substring(2,4);
    const day = PIN.substring(4,6);

    const current_year_prefix = new Date().getFullYear() % 100;

    const required_length = ( Object.is(year,NaN) || ( year > 53 ) || ( year < current_year_prefix ) ) ? 10 : 9;

    if ( required_length !== PIN_length ) {
        PIN_errors.push(props.intl.formatMessage({id: 'app.personal_forms.attribute.personal_identification_number.validation.length'}));
    }

    // Date of birth - year

    if ( PIN_length >= 2 && year !== values.data.date_of_birth_year.substring(2,4) ) {
        PIN_errors.push(props.intl.formatMessage({id: 'app.personal_forms.attribute.personal_identification_number.validation.year'}));
    }

    // Date of birth - month

    const pin_month_int = parseInt(month);
    const dob_month_int = parseInt(values.data.date_of_birth_month);

    if ( PIN_length >= 4 &&
        pin_month_int !== dob_month_int &&
        pin_month_int !== dob_month_int + 20 &&
        pin_month_int !== dob_month_int + 50 &&
        pin_month_int !== dob_month_int + 70
    ) {
        PIN_errors.push(props.intl.formatMessage({id: 'app.personal_forms.attribute.personal_identification_number.validation.month'}));
    }

    // Date of birth - day

    if ( PIN_length >= 6 && day !== values.data.date_of_birth_day ) {
        PIN_errors.push(props.intl.formatMessage({id: 'app.personal_forms.attribute.personal_identification_number.validation.day'}));
    }

    // Divisibility by 11

    if ( PIN_length === required_length && parseInt(PIN) % 11 !== 0 ) {
        PIN_errors.push(props.intl.formatMessage({id: 'app.personal_forms.attribute.personal_identification_number.validation.divisibility'}));
    }

    return PIN_errors;
};

const validateForm = function (values, props) {
    let errors = {};
    const personal_identification_number = validatePIN(values, props);

    if ( personal_identification_number.length > 0 ) {
        errors['personal_identification_number'] = personal_identification_number;
    }

    return Object.keys(errors).length > 0 ? { data: errors } : {};
};

export default injectIntl(withFormik({
    enableReinitialize: true,
    validate: validateForm,
    mapPropsToValues: (props) => {
        let model = { data: { ...props.resource.data, page: 4 } };
        return model;
    },
    handleSubmit: (values, form) => { form.props.submit(values, form); },
    displayName: 'BasicForm',
})(Page3));
